import {
    EKYCAction,
    EKYCActionType,
    IdentityVerificationAction,
    IdentityVerificationActionType,
} from './identityVerificationActionType';
import { IIdentityVerificationState } from './identityVerificationState';
import { EkycServiceAction, EkycServiceActionType } from './unlinkMyNumber/ekycServiceActionType';

export function identityVerificationReducer(
    state: IIdentityVerificationState = {
        overlayOpen: false,
        unlinkEkyc: undefined,
        linkedServices: [],
        linkedServicesConfigError: null,
        loadingLinkedServices: true,
    },
    action: IdentityVerificationAction | EKYCAction | EkycServiceAction,
) {
    switch (action.type) {
        case EKYCActionType.GET_LINKED_SERVICES_REQUEST:
            return {
                ...state,
                loadingLinkedServices: true,
            };
        case EKYCActionType.GET_LINKED_SERVICES_SUCCESS:
            return {
                ...state,
                linkedServices: action.payload,
                loadingLinkedServices: false,
            };
        case EkycServiceActionType.UNLINK_EKYCSERVICE_SUCCESS:
            const { clientId } = action.payload;
            return {
                ...state,
                linkedServices: state.linkedServices.filter(
                    (service) => service.clientId !== clientId,
                ),
            };
        case IdentityVerificationActionType.CLOSE_IDENTITY_VERIFICATION_OVERLAY:
            return {
                ...state,
                overlayOpen: false,
            };

        case IdentityVerificationActionType.OPEN_IDENTITY_VERIFICATION_OVERLAY:
            return {
                ...state,
                overlayOpen: true,
            };

        default:
            return state;
    }
}
